import * as React from "react";
import { Storage } from 'src/utils/storage'
import { withRouter, RouteComponentProps } from 'react-router-dom';

export interface Props extends RouteComponentProps {
  match: any;
}

interface State {
  permissions: any
  admin: boolean,
  loading: boolean,
  trial : boolean
}
// export const accessList:any = ["pre-trained","projects","presets","datasets","trains"]

/**
 * @param WrappedComponent
 * @param  {[type]} nextState [description]
 * @param  {[type]} replace   [description]
 * @return {[type]}           [description]
 */
export default function isAuth(WrappedComponent: any) {
  class IsAuth extends React.Component<Props, State> {
    static displayName = `IsAuth(${getDisplayName(WrappedComponent)})`

    state = {
      permissions: [] as any,
      admin: false,
      loading: true,
      trial: true
    }
    /**
     * If the user if not authenticated, redirect to "/signin"
     */
    async componentWillMount() {
      const { history } = this.props;

      let userLanguage = localStorage.getItem('userLanguage') || window.navigator.language || 'en'
      if (userLanguage.indexOf('fr') > -1) {
        userLanguage = 'fr'
      }

      if (userLanguage.indexOf('en') > -1) {
        userLanguage = 'en'
      }

      if ((userLanguage !== 'en') && (userLanguage !== 'fr')) {
        userLanguage = 'en'
      }

      if (this.props?.match?.params?.language) {
        userLanguage = this.props?.match?.params?.language
      }

      if (this.isReady() === false) {
        if (
          (window.location.pathname !== '/')
          && (window.location.pathname !== `/${userLanguage}/signin`)
          && (window.location.pathname !== '/fr/logout')
          && (window.location.pathname !== '/en/logout')
        ) {
          Storage.set('nextPage', window.location.pathname);
        }
        history.push(`/${userLanguage}/signin`)
        // window.location.href = `/${userLanguage}/signin`;
      }

      this.setState({ loading: false })
    }

    /**
     * Check if the user is already authenticated
     * @returns {boolean}
     */
    isReady = () => {
      if (localStorage.getItem("isLogged") !== "true") {
        return false;
      }
      return true;
    };

    /**
     * Render the main content
     * @returns {null}
     */
    render() {
      return this.isReady() ? <WrappedComponent {...this.props} /> : <></>
    }
  }

  return withRouter(IsAuth);
}

function getDisplayName(WrappedComponent: any) {
  return WrappedComponent !== undefined ? (WrappedComponent.displayName || WrappedComponent.name || 'Component') : 'UndefinedComponent';
}


// WEBPACK FOOTER //
// ./src/utils/isAuth/index.tsx